module.exports = __webpack_public_path__ + "static/media/AG.de89c7eb.png";